// Replace 'your-backend-url' with the actual URL of your backend API
export const API_URL = 'https://portfolio-backend-gbb5.onrender.com/api';
